// extracted by mini-css-extract-plugin
export default {"app-status-badge":"r9xL","appStatusBadge":"r9xL"};